import { render } from "./BalanceInfo.vue?vue&type=template&id=248aac49"
import script from "./BalanceInfo.vue?vue&type=script&lang=js"
export * from "./BalanceInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__